import axios from "./axios";
import config from "./config";
import eventsHub from "./eventshub";
import FileSaver from "file-saver";

class WebService {
  _headers;
  _authorization;
  _ivaExentoData = null;

  constructor() {
    this._headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    this._authorization = localStorage.getItem("authorization");
    this._ivaExentoData = localStorage.getItem("ivaExentoData");
    eventsHub.setLoggedIn(this.isLoggedIn());

    if (this._ivaExentoData !== null) {
      eventsHub.setIvaExentoData(JSON.parse(this._ivaExentoData));
    }
  }

  getHeaders() {
    let headers = {
      ...this._headers,
    };
    if (this._authorization) {
      headers.Authorization = this._authorization;
    }
    return headers;
  }

  login(email, password, cuit, transaccion) {
    const options = {
      method: "POST",
      data: {
        username: email,
        password: password,
        cuit: cuit,
        transaccion: transaccion,
        grant_type: "password",
        client_id: config.clientId,
        client_secret: config.clientSecret,
      },
    };
    return axios("/oauth/token", {
      headers: this.getHeaders(),
      ...options,
    }).then(response => {
      if (response.data.token_type && response.data.access_token) {
        this._authorization = response.data.token_type + " " + response.data.access_token;
        localStorage.setItem("authorization", this._authorization);
        eventsHub.setLoggedIn(true);
      }
      return response;
    });
  }

  logout() {
    localStorage.removeItem("authorization");
    localStorage.removeItem("ivaExentoData");
    this._authorization = null;
    eventsHub.setLoggedIn(false);
  }

  isLoggedIn() {
    return this._authorization !== null;
  }

  getUser() {
    // return axios.get("/api/whoami", { headers: this.getHeaders() }).then(response => response.data);
    return new Promise(resolve => {
      var response = { name: "TEST" };
      resolve(response);
    });
  }

  getIvaExentoData(cuit, transaccion) {
    // Fake login
    this._authorization = "1";
    localStorage.setItem("authorization", this._authorization);
    eventsHub.setLoggedIn(true);
    // End fake login

    return axios
      .get("/api/ff1272/" + cuit + "/" + transaccion, { headers: this.getHeaders() })
      .then(response => response.data);
  }

  postPeriodosFiscales(cuit, transaccion, periodosFiscales) {
    let data = {
      cuit: cuit,
      transaccion: transaccion,
      periodosFiscales: periodosFiscales,
    };
    return axios.post("/api/ff1272", data, { headers: this.getHeaders() }).then(response => response.data);
  }

  downloadFile(method, url, filename = "") {
    return axios({
      url: url,
      method: method,
      headers: this.getHeaders(),
      responseType: "blob",
    }).then(response => {
      let contentDisposition = response.headers["content-disposition"];
      if (contentDisposition && filename === "") {
        let search = 'filename="';
        let start = contentDisposition.search(search) + search.length;
        let end = 0;
        for (let i = start; i < contentDisposition.length; i++) {
          if (contentDisposition[i] === '"') {
            end = i;
            break;
          }
        }
        FileSaver.saveAs(new Blob([response.data]), contentDisposition.slice(start, end));
      } else {
        FileSaver.saveAs(new Blob([response.data]), filename);
      }
    });
  }
}

const webService = new WebService();

export default webService;
